module.exports = "../images/fishing-lodge-3-4.jpg?v=4a30d67";